import { render, staticRenderFns } from "./MenuView.vue?vue&type=template&id=13d88732&scoped=true"
import script from "./MenuView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MenuView.vue?vue&type=style&index=0&id=13d88732&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d88732",
  null
  
)

export default component.exports